<template>
    <div class="page_wrap">
        <!-- Loading 状态 -->
        <div v-if="loading" class="loading-container">
            <Spin size="large" fix>
                <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                <div>加载中...</div>
            </Spin>
        </div>
        <!-- 根据认证状态显示不同组件 -->
        <template v-else>
            <NotCertified v-if="!isCertified"  @refresh="goUpdate" />
            <BasicInfoContent v-else />
        </template>
    </div>
</template>

<script>
import { get_enterprise_info } from '@/api/interFace'
import NotCertified from './components/NotCertified'
import BasicInfoContent from './components/BasicInfoContent'

export default {
    name: 'enterprise-basic-info',
    components: {
        NotCertified,
        BasicInfoContent
    },
    data() {
        return {
            loading: true, // 加载状态
            isCertified: false,
            enterpriseInfo: {}
        }
    },
    created() {
        this.getEnterpriseInfo()
    },
    methods: { 
        goUpdate() {
            this.getEnterpriseInfo()
            setTimeout(() => { 
                // window.location.reload();  //清除缓存刷新页面
                location.reload();
            }, 500)
        },
        getEnterpriseInfo() {
            this.loading = true
            get_enterprise_info({ enterprise_auth_id: localStorage.getItem('enterprise_auth_id') || '' }).then(res => { 
                if (res.code === 200) {
                    // 判断是否有企业信息
                    // 如果 res.data 为空数组、空对象或不存在 enterprise_info，则表示未认证
                    if (Array.isArray(res.data) && res.data.length === 0) {
                        // 空数组，未认证
                        this.enterpriseInfo = {}
                        this.isCertified = false
                    } else if (!res.data || (typeof res.data === 'object' && Object.keys(res.data).length === 0)) {
                        // 空对象，未认证
                        this.enterpriseInfo = {}
                        this.isCertified = false
                    } else if (!res.data.enterprise_info || (typeof res.data.enterprise_info === 'object' && Object.keys(res.data.enterprise_info).length === 0)) {
                        // enterprise_info 不存在或为空，未认证
                        this.enterpriseInfo = {}
                        this.isCertified = false
                    } else {
                        // 有企业信息，已认证
                        this.enterpriseInfo = res.data.enterprise_info || res.data
                        if(this.enterpriseInfo.id && !localStorage.getItem('enterprise_auth_id') ) {
                            localStorage.setItem('enterprise_auth_id', this.enterpriseInfo.id)
                        }
                        this.isCertified = true
                    }
                } else {
                    // 接口返回错误，未认证
                    this.enterpriseInfo = {}
                    this.isCertified = false
                }
            }).catch(err => {
                console.log('获取企业信息失败:', err)
                // 接口失败，未认证
                this.enterpriseInfo = {}
                this.isCertified = false
                localStorage.setItem('enterprise_auth_id', '')
                this.$Message.error(err.msg || '获取企业信息失败')
            }).finally(() => {
                // 无论成功还是失败，都关闭 loading
                this.loading = false
            })
        }
    }
}
</script>

<style scoped lang="scss">
.page_wrap {
    width: 100%;
    min-height: 100%;
    background: #EDF0F9;
    position: relative;
}

.loading-container {
    width: 100%;
    min-height: 100vh;
    position: relative;
}

.spin-icon-load {
    animation: ani-spin 1s linear infinite;
}

@keyframes ani-spin {
    from {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(180deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
